<template>
<div class="search">
  <div class="title">申报信息</div>
  <div class="order">
    <div class="head">
      <div class="items">
        <div class="ite">
          <div class="ite-left">系统唯一序号:</div>
          <div class="ite-right">{{ row.guid || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">报送类型:</div>
          <div class="ite-right">{{ appTypeObj[row.appType] || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">报送时间:</div>
          <div class="ite-right">{{ row.appTime || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">报送状态:</div>
          <div class="ite-right">{{ appStatusObj[row.appStatus] || '--'}}</div>
        </div>
      </div>
      <div class="items">
        <div class="ite">
          <div class="ite-left">申报地海关代码:</div>
          <div class="ite-right">{{ row.customsCode || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">电商平台代码:</div>
          <div class="ite-right">{{ row.ebpCode || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">电商平台名称:</div>
          <div class="ite-right">{{ row.ebpName || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">订单编号:</div>
          <div class="ite-right">{{ row.orderNo || '--'}}</div>
        </div>
      </div>
      <div class="items">
        <div class="ite">
          <div class="ite-left">电子口岸编号:</div>
          <div class="ite-right">{{ row.preNo|| '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">清单编号:</div>
          <div class="ite-right">{{  row.invtNo || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">进出口标记:</div>
          <div class="ite-right">{{ row.ieFlag || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">出口日期:</div>
          <div class="ite-right">{{ row.ieDate || '--'}}</div>
        </div>
      </div>
      <div class="items">
        <div class="ite">
          <div class="ite-left">申报业务类型:</div>
          <div class="ite-right">{{ row.statisticsFlag || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">区内企业代码:</div>
          <div class="ite-right">{{ row.agentCode || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">区内企业名称:</div>
          <div class="ite-right">{{ row.agentName || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">贸易方式:</div>
          <div class="ite-right">{{ row.tradeMode || '--'}}</div>
        </div>
      </div>
    </div>
  <div>
  </div>
  </div>
  <div class="title">企业信息</div>
  <div class="order">
    <div class="head">
      <div class="items">
        <div class="ite">
          <div class="ite-left">企业唯一编号:</div>
          <div class="ite-right">{{ row.copNo || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">申报企业代码:</div>
          <div class="ite-right">{{ row.agentCode || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">申报企业名称:</div>
          <div class="ite-right">{{ row.agentName || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">生产销售企业代码:</div>
          <div class="ite-right">{{ row.ownerCode || '--'}}</div>
        </div>
      </div>
      <div class="items">
        <div class="ite">
          <div class="ite-left">生产销售企业名称:</div>
          <div class="ite-right">{{ row.ownerName || '--'}}</div>
        </div>
        <div class="ite">
          <!-- <div class="ite-left">账册编号:</div>
          <div class="ite-right">{{ row.emsNo || '--'}}</div> -->
        </div>
        <div class="ite">
          <div class="ite-left">收发货人代码:</div>
          <div class="ite-right">{{ row.ebcCode || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">收发货人名称:</div>
          <div class="ite-right">{{ row.ebcName || '--'}}</div>
        </div>
      </div>
    </div>
  <div>
  </div>
  </div>
  <div class="title">物流信息</div>
  <div class="order">
    <div class="head">
      <div class="items">
        <div class="ite">
          <div class="ite-left">物流企业代码:</div>
          <div class="ite-right">{{ row.logisticsCode || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">物流企业名称:</div>
          <div class="ite-right">{{ row.logisticsName || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">物流运单编号:</div>
          <div class="ite-right">{{ row.logisticsNo || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">提运单号:</div>
          <div class="ite-right">{{ row.billNo || '--'}}</div>
        </div>
      </div>
      <div class="items">
        <div class="ite">
          <div class="ite-left">运输方式代码:</div>
          <div class="ite-right">{{ row.trafMode || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">运输方式工具名称:</div>
          <div class="ite-right">{{ row.trafName || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">航班班次号:</div>
          <div class="ite-right">{{ row.voyageNo || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">抵运国:</div>
          <div class="ite-right">{{ row.country|| '--'}}</div>
        </div>
      </div>
      <div class="items">
        <div class="ite">
          <div class="ite-left">总包号:</div>
          <div class="ite-right">{{ row.totalPackageNo|| '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">监管场所代码:</div>
          <div class="ite-right">{{ row.loctNo || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">许可证号:</div>
          <div class="ite-right">{{ row.licenseNo || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">运费标志:</div>
          <div class="ite-right">{{ row.fflag || '--'}}</div>
        </div>
      </div>
      <div class="items">
        <div class="ite">
          <div class="ite-left">抵运港代码:</div>
          <div class="ite-right">{{ row.pod || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">运费:</div>
          <div class="ite-right">{{ row.freight || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">运费币制:</div>
          <div class="ite-right">{{ row.fcurrency || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">包装种类代码:</div>
          <div class="ite-right">{{ row.wrapType || '--'}}</div>
        </div>
      </div>
      <div class="items">
        <div class="ite">
          <div class="ite-left">保费:</div>
          <div class="ite-right">{{ row.insuredFee || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">保费币制:</div>
          <div class="ite-right">{{ row.icurrency || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">保费标志:</div>
          <div class="ite-right">{{ row.iflag || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">备注:</div>
          <div class="ite-right">{{ row.note || '--'}}</div>
        </div>
      </div>
      <div class="items">
        <div class="ite">
          <div class="ite-left">件数:</div>
          <div class="ite-right">{{ row.packNo || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">毛重（千克）:</div>
          <div class="ite-right">{{ row.grossWeight || '--'}}</div>
        </div>
        <div class="ite">
          <div class="ite-left">净重（千克）:</div>
          <div class="ite-right">{{ row.netWeight || '--'}}</div>
        </div>
        <div class="ite">
        </div>
      </div>

    </div>
  <div>
  </div>
  </div>
  <div class="ux-filter-records filter-records">
            <div class='content-list' style="height:auto">
              <el-table
                empty-text="暂无数据"
                class="table ux-dark-el-table"
                :data="tableData"
                max-height="365"
                element-loading-spinner="el-icon-loading">
                <el-table-column width='80' type='index' label='序号' align='center'>
                  </el-table-column>
                  <el-table-column v-for="(props, i) in tableHeader" :label='props.label' align="left" :key="i" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div class="text">{{ scope.row[props.name] || '--' }}</div>
                    </template>
                  </el-table-column>
              </el-table>
            </div>
            <div class='pages'>
              <span>共 {{ page.total }} 条数据</span>
              <el-pagination
                class="ux-dark-el-pagination"
                small
                background
                layout="prev, pager, next"
                :current-page="page.current"
                :page-size="page.size"
                :total="page.total"
                @current-change="currentChange"
              />
              <pagination @currentChange="currentChange" @sizeChange="sizeChange"/>
            </div>
          </div>
</div>
</template>
<script>
import pagination from '@/components/main/bigData/home/compontents/pagination.vue'
import apiPath from '@config/api.json'
const {mapState} = require('vuex')
export default {
  components: {pagination},
  props: {
    row: {
      type: Object,
      default: () => {}
    },
    appTypeObj: {
      type: Object,
      default: () => {}
    },
    appStatusObj: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      tableData: [],
      tableHeader: [
        {
          label: '企业商品货号',
          name: 'itemNo'
        },
        {
          label: '企业商品名称',
          name: 'itemName'
        },
        {
          label: '条形码',
          name: 'barCode'
        },
        {
          label: '计量单位',
          name: 'unit'
        },
        {
          label: '币种',
          name: 'currency'
        },
        {
          label: '数量',
          name: 'qty'
        },
        {
          label: '单价',
          name: 'price'
        },
        {
          label: '总价',
          name: 'totalPrice'
        },
        {
          label: '备注',
          name: 'note'
        }
      ],
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapState({
      searchDate: (state) => {
        return state.home.searchDate
      }
    })
  },
  methods: {
    currentChange (e) {
      this.page.current = e
      this.getList()
    },
    sizeChange (e) {
      this.page.current = 1
      this.page.size = e
      this.getList()
    },
    getList () {
      let data = {
        'pageNum': this.page.current,
        'pageSize': this.page.size,
        guid: this.row.guid,
        customerNo: this.row.info.customerNo
      }
      this.$ajax({
        method: 'post',
        url: `${apiPath.bigData.search.bg.tabs.getDeclarationClearanceItem}`,
        data: data
      }).then(res => {
        if (res) {
          const dataInfo = res.data || {}
          let getList = dataInfo.records || []
          this.tableData = getList
          this.page.total = dataInfo.total || 0
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
 .title{
  margin-bottom: 10px;
 }
.order {
  width: calc(100% - 40px);
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0);
  border: 1px solid rgba(37, 92, 152, 1);
  margin-bottom: 10px;

  .head {
    padding: 28px 28px 0px;
    .items {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 40px;
      .ite {
        display: flex;
        width: 25%;
        .ite-left {
          width: 50%;
          text-align: right;
        }
        .ite-right {
          width: 50%;
          text-align: left;
          margin-left: 5px;
        }
      }
    }
  }
}

</style>
<style lang="scss">
.ux-filter-records {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 20px 35px 0px 0px;
    box-sizing: border-box;
    .filter {
      display: flex;
      flex-wrap: wrap;
      // div {
      //   margin-right: 18px;
      //   margin-bottom: 10px;
      // }
      .search {
        color: #ffffff;
        background: #1c8be2;
      }
    }
    .content-list {
      margin-top: 10px;
      flex: none;
      // min-height: 550px;
      .table {
        height: 100%;
        .el-table__header-wrapper {
          tr {
            th {
              height: 50px;
            }
          }
        }
        .el-table__body-wrapper {
          tr {
            td {
              height: 50px;
            }
          }
        }
        .el-loading-mask {
          /* background: rgba(0, 0, 0, 0.8); */
          .el-loading-spinner {
            font-size: 24px;
          }
        }
        .text {
          font-size: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
      }
      .ux-dark-el-table {
        display: flex;
        flex-direction: column;
        border: 1px solid #2d6bab;
        background-color: transparent;
        table {
        thead {
          tr {
            background: rgba(24, 127, 215, 0.1) !important;
            &:last-child {
              td {
                border-bottom: none;
              }
            }
            th {
              padding: 0;
              border-color: #2d6bab !important;
              background: rgba(24, 127, 215, 0.3) !important;
              &:last-child {
                border-right: none;
              }
              .cell {
                font-size: 16px;
                font-family: SourceHanSansCN-Medium, SourceHanSansCN;
                font-weight: 500;
                color:#fff;
                // background: linear-gradient(180deg, #eeeeee 0%, #4dc5ff 100%);
                // background-clip: text;
                // -webkit-text-fill-color: transparent;
              }
            }
            td {
              padding: 0;
              font-size: 14px;
              font-family: SourceHanSansCN-Medium, SourceHanSansCN;
              font-weight: 500;
              color: #ffffff;
              border-color: #2d6bab;
              &:last-child {
                border-right: none;
              }
            }
          }
        }
        }
        td.el-table__cell{
          border-bottom: 1px solid #2d6bab;
        }
        &::before {
          display: none;
        }
        // tbody row hover
        &.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
          background: rgba(24, 127, 215, 0.2);
        }
        // 多级表头
        &.el-table--group::after,
        // 带边框表格
        &.el-table--border::after {
          content: unset;
        }
        .el-table__body-wrapper {
          flex: 1 1;
          table {
            height: 100%;
          }
        }
        .el-table__footer-wrapper tbody td.el-table__cell {
          font-size: 16px;
          background-color: transparent;
        }
      }
    }
    .pages {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      height: 28px;
      font-size: 16px;
      font-weight: 400;
      color: #fff;
    }
  }</style>



// WEBPACK FOOTER //
// src/components/main/bigData/search/compontents/components/Manifest.vue